import cep from 'cep-promise';

export default {
    recuperarCEP(codigoCEP) {
        return cep(codigoCEP, {timeout: 10000, providers: ['brasilapi']})
    }
}


